import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#03A2FF',
        secondary: '#00A896',
      },
      dark: {
        primary: '#03A2FF',
        secondary: '#00A896',
      },
    },
  },
});
